import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

import { PermissionSlug } from '../constants/featureFlags';
import { useStore } from '../store';

const SUPERUSER_BANNER_DISMISSED_KEY = 'roger-superuser-mode-banner-dismissed';

function wasDismissedInThisSession(): boolean {
  try {
    return (
      window.sessionStorage.getItem(SUPERUSER_BANNER_DISMISSED_KEY) === 'true'
    );
  } catch {
    return false;
  }
}

const SuperuserModeBanner: React.FC = () => {
  const isSuperuser = useStore(state =>
    state.hasPermission(PermissionSlug.ADMIN_SUPER_USER)
  );
  const [isDismissed, setIsDismissed] = useState(wasDismissedInThisSession);

  if (!isSuperuser || isDismissed) return null;

  const dismiss = () => {
    try {
      window.sessionStorage.setItem(SUPERUSER_BANNER_DISMISSED_KEY, 'true');
    } catch {
      // Keep the dismissal in memory when browser storage is unavailable.
    }
    setIsDismissed(true);
  };

  return (
    <div
      role='status'
      className='flex flex-col gap-2 bg-red-600 px-3 py-2 text-white sm:flex-row sm:items-center sm:px-4'
    >
      <div className='flex min-w-0 flex-1 flex-wrap items-center gap-x-2 gap-y-1'>
        <AlertTriangle aria-hidden='true' className='h-4 w-4 shrink-0' />
        <span className='font-bold'>Superuser mode active</span>
        <span
          aria-hidden='true'
          className='hidden h-4 border-l border-white/70 sm:block'
        />
        <span className='text-sm'>
          You are currently using a Roger superuser session.
        </span>
      </div>
      <button
        type='button'
        className='flex shrink-0 self-end items-center gap-1 rounded px-2 py-1 text-sm font-medium text-white hover:bg-white/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:self-auto'
        onClick={dismiss}
      >
        <X aria-hidden='true' className='h-4 w-4' /> Dismiss
      </button>
    </div>
  );
};

export default SuperuserModeBanner;
